"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSplitButtonSlots = exports.default = exports.SplitButton = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _splitButtonClasses = _interopRequireWildcard(require("./splitButtonClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
var getSplitButtonSlots = function(ownerState) {
    var fullWidth = ownerState.fullWidth, color = ownerState.color, size = ownerState.size, disabled = ownerState.disabled, loading = ownerState.loading, edge = ownerState.edge;
    return {
        root: [
            'root',
            "color".concat((0, _utils.capitalize)(color)),
            "size".concat((0, _utils.capitalize)(size)),
            "edge".concat((0, _utils.capitalize)(edge)),
            fullWidth && 'fullWidth',
            disabled && 'disabled',
            loading && 'loading'
        ],
        button: [
            'button'
        ],
        content: [
            'content'
        ]
    };
};
exports.getSplitButtonSlots = getSplitButtonSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getSplitButtonSlots(ownerState);
    return (0, _base.unstable_composeClasses)(slots, _splitButtonClasses.getSplitButtonUtilityClass, classes);
};
var SplitButtonRoot = (0, _material.styled)('span', {
    name: 'MuiOriSplitButton',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            styles["color".concat((0, _utils.capitalize)(ownerState.color))],
            styles["size".concat((0, _utils.capitalize)(ownerState.size))],
            styles["edge".concat((0, _utils.capitalize)(ownerState.edge))],
            ownerState.disabled && styles.disabled,
            ownerState.loading && styles.loading,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread_props(_object_spread({
        display: 'inline-grid',
        gridTemplateAreas: '"content button"',
        border: '1px solid',
        borderRadius: 25,
        gridTemplateColumns: "".concat(ownerState.contentWidth, " 1fr"),
        borderColor: theme.palette[ownerState.color].main,
        minWidth: 'min(320px, 100%)',
        overflow: 'hidden'
    }, ownerState.color === 'primary' && {
        borderColor: theme.palette.default.dark
    }, ownerState.size === 'small' && {
        minWidth: 'min(280px, 100%)'
    }, ownerState.edge === 'start' && {
        gridTemplateAreas: '"button content"',
        gridTemplateColumns: "1fr ".concat(ownerState.contentWidth)
    }, ownerState.fullWidth && {
        width: '100%'
    }, ownerState.loading && {
        borderColor: theme.palette.grey[200]
    }), _define_property({}, "&.".concat(_splitButtonClasses.default.disabled), {
        borderColor: theme.palette.grey[200],
        color: theme.palette.grey.A400,
        background: theme.palette.grey[200],
        pointerEvents: 'none'
    }));
});
var Button = (0, _material.styled)(_material.ButtonBase, {
    name: 'MuiOriSplitButton',
    slot: 'Button',
    overridesResolver: function(_, styles) {
        return [
            styles.button
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread(_object_spread_props(_object_spread({
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText,
        gridArea: 'button',
        alignSelf: 'stretch',
        justifySelf: 'stretch',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        padding: '11px 22px'
    }, theme.typography.button, ownerState.size === 'small' && {
        padding: '8px 19px',
        fontSize: '1.3rem',
        lineHeight: 1.75
    }), {
        '&:hover': {
            backgroundColor: theme.palette[ownerState.color].dark,
            '@media (hover: none)': {
                backgroundColor: theme.palette[ownerState.color].main
            }
        }
    }), ownerState.color === 'primary' && _define_property({
        background: theme.palette.default.dark,
        color: theme.palette.default.contrastText,
        '&:hover': {
            background: theme.palette.grey.A700,
            '@media (hover: none)': {
                background: theme.palette.default.dark
            }
        }
    }, "&.".concat(_base.buttonClasses.disabled), {
        background: theme.palette.grey[200]
    }), (ownerState.loading || ownerState.disabled) && {
        background: theme.palette.grey[200],
        color: theme.palette.grey.A400
    });
});
var Content = (0, _material.styled)('div', {
    name: 'MuiOriSplitButton',
    slot: 'Content',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.content
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return _object_spread({
        gridArea: 'content',
        alignSelf: 'center',
        display: 'flex',
        alignItems: 'center'
    }, ownerState.edge === 'end' && {
        borderRadius: '25px 0 0 25px'
    }, ownerState.edge === 'start' && {
        borderRadius: '0 25px 25px 0'
    });
});
var LoadingIndicator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.CircularProgress, {
    color: "inherit",
    size: "1.8rem"
});
var SplitButton = exports.SplitButton = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriSplitButton'
    });
    var className = props.className, buttonContent = props.buttonContent, _props_ButtonComponent = props.ButtonComponent, ButtonComponent = _props_ButtonComponent === void 0 ? Button : _props_ButtonComponent, ButtonProps = props.ButtonProps, onClick = props.onClick, _props_loadingIndicator = props.loadingIndicator, loadingIndicator = _props_loadingIndicator === void 0 ? LoadingIndicator : _props_loadingIndicator, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_loading = props.loading, loading = _props_loading === void 0 ? false : _props_loading, _props_edge = props.edge, edge = _props_edge === void 0 ? 'end' : _props_edge, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, _props_contentWidth = props.contentWidth, contentWidth = _props_contentWidth === void 0 ? 'auto' : _props_contentWidth, _props_component = props.component, component = _props_component === void 0 ? 'span' : _props_component, fullWidth = props.fullWidth, children = props.children, rest = _object_without_properties(props, [
        "className",
        "buttonContent",
        "ButtonComponent",
        "ButtonProps",
        "onClick",
        "loadingIndicator",
        "disabled",
        "loading",
        "edge",
        "color",
        "size",
        "contentWidth",
        "component",
        "fullWidth",
        "children"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        edge: edge,
        color: color,
        disabled: disabled,
        loading: loading,
        size: size,
        contentWidth: contentWidth,
        fullWidth: fullWidth
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SplitButtonRoot, _object_spread_props(_object_spread({
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className)
    }, rest), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Content, {
                ownerState: ownerState,
                className: classes.content,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonComponent, _object_spread_props(_object_spread({
                disabled: disabled || loading,
                ownerState: ownerState,
                className: classes.button,
                onClick: onClick
            }, ButtonProps), {
                children: loading ? loadingIndicator : buttonContent
            }))
        ]
    }));
});
var _default = exports.default = SplitButton; //# sourceMappingURL=SplitButton.js.map
